import { useCallback, useEffect, useMemo, useState } from "react";
import { UrlApi } from "../../../services/apirest";
import { Box } from "@mui/material";
import DataTable from "../dataTable/DataTable";
import Navbar from "../../Navbar";
import Calendar from "../calendar/Calendar";

const currentYear = new Date().getFullYear();

const Index = () => {
  const [year, setYear] = useState(currentYear);
  const [branch, setBranch] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [events, setEvents] = useState([]);

  // ----------- CALENDARIO -------------
  const getDataForCalendar = useCallback(async () => {
    try {
      const usp = new URLSearchParams();
      const bNum = branch != null && branch !== "" ? Number(branch) : null;
      if (bNum) usp.set("branchId", String(bNum));

      const res = await fetch(`${UrlApi}/vacations/calendar?${usp.toString()}`);
      if (!res.ok) throw new Error("Error al traer el calendario");

      const json = await res.json();
      const data = json.data || [];
      setEvents(
        data.map((e) => ({
          ...e,
          start: new Date(e.start),
          end: new Date(e.end),
        }))
      );
    } catch (err) {
      console.error("Error obteniendo datos del calendario:", err);
    }
  }, [branch]);

  useEffect(() => {
    getDataForCalendar();
  }, [getDataForCalendar]);

  // ----------- EMPLEADOS -------------

  const requestUrl = useMemo(() => {
    const usp = new URLSearchParams();
    const y = Number(year);
    if (!Number.isFinite(y)) return null;
    usp.set("year", String(y));

    const bNum = branch != null && branch !== "" ? Number(branch) : null;
    if (bNum) usp.set("branchId", String(bNum));

    return `${UrlApi}/vacations?${usp.toString()}`;
  }, [year, branch]);

  const fetchEmployees = useCallback(async () => {
    if (!requestUrl) {
      setEmployees([]);
      return;
    }

    try {
      const res = await fetch(requestUrl);
      if (!res.ok) {
        let message = `HTTP ${res.status}`;
        try {
          const body = await res.json();
          if (body?.error) message = body.error;
        } catch {}
        throw new Error(message);
      }

      const data = await res.json();
      setEmployees(Array.isArray(data) ? data : []);
    } catch (err) {
      setEmployees([]);
    }
  }, [requestUrl]);

  // carga inicial o cuando cambian filtros
  useEffect(() => {
    fetchEmployees();
  }, [requestUrl]);

  useEffect(() => {
    getDataForCalendar();
  }, [employees]);

  return (
    <>
      <Navbar />
      <>
        <DataTable
          employees={employees}
          year={year}
          setYear={setYear}
          branch={branch}
          setBranch={setBranch}
          getEmployees={fetchEmployees}
        />
        <Calendar events={events} />
        <Box sx={{ mb: 10 }} />
      </>
    </>
  );
};

export default Index;
